import React from 'react'
import RenderType from './type'
import { Table } from '~/components'
import RenderPayment from './payment'

export default function FinanceView({
    finances,
    onCreateInvoice,
    processingReceitaIds = [],
    isMobile = false,
}) {
    return (
        <Table
            requestingMessage="Obtendo finanças..."
            headers={[
                { title: 'Tipo', render: item => <RenderType item={item} /> },
                { title: 'Referência', field: 'dtReference' },
                {
                    title: 'Valor',
                    render: item =>
                        'R$ ' + item.valueWithFare.replace('.', ','),
                },
                { title: 'Vencimento', field: 'dtVencto' },
                { title: 'Data de Pagamento', field: 'dtPagto' },
                {
                    title: 'Imprimir',
                    className: 'command',
                    render: item => (
                        <RenderPayment
                            item={item}
                            loading={processingReceitaIds.includes(
                                item.idReceita
                            )}
                            onCreateInvoice={onCreateInvoice}
                            isMobile={isMobile}
                        />
                    ),
                },
            ]}
            rows={finances}
            rowClassName={({ isPaid }) => (isPaid ? 'paid' : '')}
        />
    )
}
